<template>
  <div id="app">
    <my-header></my-header>
    <my-menu></my-menu>
    <div class="c-content" :class="{ 'c-content--desktop': device === 2 }">
      <my-hero></my-hero>
      <my-intro></my-intro>
      <my-focus></my-focus>
      <my-future></my-future>
      <my-operations></my-operations>
      <my-vision></my-vision>
      <my-people></my-people>
      <my-governance></my-governance>
      <my-financial></my-financial>
      <my-services></my-services>
      <my-footer></my-footer>
    </div>
    <my-download></my-download>
    <my-video></my-video>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import MyHeader from '@/components/single/MyHeader'
import MyMenu from '@/components/single/MyMenu'
import MyHero from '@/components/single/MyHero'
import MyIntro from '@/components/single/MyIntro'
import MyFocus from '@/components/single/MyFocus'
import MyFuture from '@/components/single/MyFuture'
import MyOperations from '@/components/single/MyOperations'
import MyVision from '@/components/single/MyVision'
import MyPeople from '@/components/single/MyPeople'
import MyGovernance from '@/components/single/MyGovernance'
import MyFinancial from '@/components/single/MyFinancial'
import MyServices from '@/components/single/MyServices'
import MyFooter from '@/components/single/MyFooter'
import MyDownload from '@/components/single/MyDownload'
import MyVideo from '@/components/single/MyVideo'
import { eventBus } from '@/main'

export default {
  name: 'app',
  components: {
    MyHeader,
    MyMenu,
    MyHero,
    MyIntro,
    MyFocus,
    MyFuture,
    MyOperations,
    MyVision,
    MyPeople,
    MyGovernance,
    MyFinancial,
    MyServices,
    MyFooter,
    MyDownload,
    MyVideo
  },
  computed: {
    device () {
      return this.$store.state.device
    },
    menuOpen () {
      return this.$store.state.menuOpen
    },
    downloadOpen () {
      return this.$store.state.downloadOpen
    }
  },
  methods: {
    resizeDebounce () {
      eventBus.$emit('viewport-has-finished-resizing')
    },
    resizeThrottle () {
      eventBus.$emit('viewport-is-resizing')
      this.setDevice()
    },
    fetchData () {
      let _this = this
      // axios.get('http://ukpn-review-2017-admin.dev/api')
      axios.get('/annualreview2017/static/content.json')
      // axios.get('http://ukpn-admin.trafiqdev.co.uk/api')
      .then(function (response) {
        eventBus.$emit('content-has-loaded')
        _this.$store.commit('setContent', response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setDevice () {
      this.$store.commit('setWindow')
      if (window.matchMedia('(min-width: 75em)').matches) {
        this.$store.commit('setDevice', 2)
      } else if (window.matchMedia('(min-width: 51.5em)').matches) {
        this.$store.commit('setDevice', 1)
      } else {
        this.$store.commit('setDevice', 0)
      }
    }
  },
  created () {
    this.fetchData()
    this.setDevice()
    this.$nextTick(function () {
      window.addEventListener('resize', debounce(this.resizeDebounce, 1000))
      window.addEventListener('resize', throttle(this.resizeThrottle, 300))
    })
  }
}
</script>

<style src="./assets/styles/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?dda2483a